import { Box, TextField } from '@mui/material'
import LabelErrorTAG from '../LabelErrorTAG'
import { ITextInput } from './types'

const TextInput: React.FC<ITextInput> = ({
  fieldName,
  label,
  register,
  error,
  validation = {}, 
  placeholder = '',
  type = 'text',
  disabled = false,
}) => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <LabelErrorTAG label={label} />
      <TextField
        {...register(fieldName, validation)}
        variant='standard'
        type={type}
        id='username-input'
        aria-describedby='username-helper-text'
        fullWidth
        placeholder={placeholder}
        disabled={disabled}
        error={!!error}                       
        helperText={error || ''} 
      />
    </Box>
  )
}

export default TextInput
